<template>
  <section ref="anchor" class="overhead">
    <div class="clue">{{ content.clue }}</div>

    <div class="overhead__content">
      <div class="overhead__content_left">
        <img :src="`/img/overhead-logo.png`" />
      </div>

      <div class="overhead__content_right">
        <div class="font-medium block__title">
          <span class="block__title_one">{{ content.titleOne }}</span>
          <span class="block__title_two">{{ content.titleTwo }}</span>
          <span class="block__title_three">{{ content.titleThree }}</span>
        </div>

        <div class="font-medium block__description">
          {{ content.description }}
        </div>

        <div class="font-small button" @click="openLink">
          {{ content.button }}
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { electronicOverheadData } from '@/content/data'
import offsetMixin from '@/mixins/offsetMixin'

export default {
  name: 'ElectronicOverhead',
  mixins: [offsetMixin],
  data() {
    return {
      content: electronicOverheadData,
    }
  },
  methods: {
    openLink() {
      const url =
        'https://kontur42.ru/logistika/tpost/kkpxd6aba1-zakon-140-fz-ot-7-iyunya-2025-goda-chto'

      window.open(url, '_blank')
    },
  },
}
</script>

<style lang="sass" scoped>
.overhead
  background: $textLightWhite
  padding: 8rem $desktopHorizontalPaddings 8rem
  @media (max-width: 1279px)
    padding: 4rem $mobileHorizontalPaddings 4rem
  &__content
    display: flex
    justify-content: space-between
    width: 100%
    gap: 2rem
    @media (max-width: 1024px)
      flex-direction: column-reverse

  .clue
    width: 33%
    margin-bottom: 2rem
    @media (max-width: 1024px)
      width: 100%
      text-align: left

  &__content_left
    margin: auto 0
    width: 30%
    @media (min-width: 1280px) and (max-width: 1919px)
      width: 40%
    @media (max-width: 1280px)
      width: 100%
      display: flex
      justify-content: center

  &__content_right
    width: 70%
    display: flex
    flex-direction: column
    gap: 3rem
    @media (min-width: 1280px) and (max-width: 1919px)
      width: 60%
    @media (max-width: 1280px)
      width: 100%

  .block__title
    font-family: $primaryFont
    font-weight: 500
    font-size: 3.2rem
    line-height: 4rem
    @media (min-width: 1280px) and (max-width: 1439px)
      font-size: 3rem
    @media (max-width: 1279px)
      font-size: 2.4rem
    &_two
      font-size: 3.2rem
      line-height: 4rem
      color: $buttonPrimary
      @media (min-width: 1280px) and (max-width: 1439px)
        font-size: 3rem
      @media (max-width: 1279px)
        font-size: 2.4rem
    &_two
      font-size: 3.2rem !important
      line-height: 4rem
      color: $textSecondary
    &_three
      font-size: 3.2rem !important
      line-height: 4rem
      color: $buttonPrimary

  .block__description
    font-family: $primaryFont
    font-weight: 500
    font-size: 3.2rem
    line-height: 4rem
    @media (min-width: 1280px) and (max-width: 1439px)
      font-size: 3rem
    @media (max-width: 1279px)
      font-size: 2.4rem

  .button
    min-width: 280px
    max-width: 40%
    height: 5rem
    font-weight: 400
    font-size: 1.8rem
    line-height: 2.4rem
    padding: 1rem 3rem
    color: $buttonPrimary
    border: 1px solid $buttonPrimary
    display: flex
    justify-content: center
    align-items: center
    border-radius: 50px
    background-color: transparent
    cursor: pointer
    @media (max-width: 1024px)
      max-width: 100%
    @media (max-width: 768px)
      height: auto
</style>
